module.exports = __webpack_public_path__ + "img/major.d529255f.png";